export { default as Loader } from '@components/loader/Loader';
export { default as LoaderProgress } from '@components/loader/LoaderProgress';


// WEBPACK FOOTER //
// ./src/components/loader/index.ts